import { CdkDropList } from '@angular/cdk/drag-drop';
import { Directive, HostBinding, Input, OnChanges, OnDestroy, OnInit, inject, input } from '@angular/core';
import { MatButton, MatIconButton, MatMiniFabButton } from '@angular/material/button';
import { MatMenuItem } from '@angular/material/menu';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTab } from '@angular/material/tabs';
import { SelectMultipleStructuresComponent } from '@app/features/editeur/components/sidebar/editeur-objet-maquette/descripteurs-format-enseignements/select-multiple-structures/select-multiple-structures.component';
import { MenuEntryComponent } from '@pcscol-portail/composants-pegase';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AutorisationsService } from '../autorisations.service';

@Directive({ selector: '[appEnableIfAutorise]' })
export class EnableIfAutoriseDirective implements OnInit, OnDestroy, OnChanges {
    private _service = inject(AutorisationsService);
    matButton = inject(MatButton, { optional: true, host: true, self: true })!;
    matMenuItem = inject(MatMenuItem, { optional: true, host: true, self: true })!;
    matMiniFabButton = inject(MatMiniFabButton, { optional: true, host: true, self: true })!;
    matSlideToggle = inject(MatSlideToggle, { optional: true, host: true, self: true })!;
    matTab = inject(MatTab, { optional: true, host: true, self: true })!;
    multiselectStructure = inject(SelectMultipleStructuresComponent, { optional: true, host: true, self: true })!;
    pegaseMenuEntry = inject(MenuEntryComponent, { optional: true, host: true, self: true })!;
    cdkDropList = inject(CdkDropList, { optional: true, host: true, self: true })!;
    matIconButton = inject(MatIconButton, { optional: true, host: true, self: true })!;

    private destroy$ = new Subject<void>();
    protected traitements: string | string[];
    private _estAutorise: boolean = false;
    public get estAutorise(): boolean {
        return this._estAutorise && !this.isHostDisabled();
    }
    @HostBinding('class.disabled') disabledClass: boolean;
    // eslint-disable-next-line @angular-eslint/no-input-rename
    readonly isHostDisabled = input<boolean>(false, { alias: 'disabled' });

    @Input()
    set appEnableIfAutorise(traitement: string | string[]) {
        this.traitements = traitement;
    }

    /**
     * Si true passé en param : l'élément ne sera pas disabled
     */
    readonly overrideAutorisationCondition = input<boolean>(false);

    ngOnInit(): void {
        this.checkInjection();
        this.checkTraitements();
    }

    private checkTraitements() {
        if (this.overrideAutorisationCondition()) {
            this._estAutorise = true;
            this.toggleElementDisabled();
        } else if (Array.isArray(this.traitements)) {
            this._service
                .isAutoriseSurAuMoinsUnDesTraitements$(this.traitements)
                .pipe(takeUntil(this.destroy$))
                .subscribe((estAutorise: boolean) => {
                    this._estAutorise = estAutorise;
                    this.toggleElementDisabled();
                });
        } else {
            this._service
                .isAutorise$(this.traitements)
                .pipe(takeUntil(this.destroy$))
                .subscribe((estAutorise: boolean) => {
                    this._estAutorise = estAutorise;
                    this.toggleElementDisabled();
                });
        }
    }

    protected checkInjection() {
        if (
            !this.matButton &&
            !this.matMenuItem &&
            !this.matMiniFabButton &&
            !this.matSlideToggle &&
            !this.matTab &&
            !this.multiselectStructure &&
            !this.pegaseMenuEntry &&
            !this.cdkDropList &&
            !this.matIconButton
        ) {
            throw new Error('IfAutoriseDirective: aucune instance de MatButton trouvée.');
        }
    }

    ngOnChanges(): void {
        this.toggleElementDisabled();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    toggleElementDisabled() {
        const disabled: boolean = !this.estAutorise;
        this.disabledClass = disabled;
        if (this.matButton) {
            this.matButton.disabled = disabled;
        }
        if (this.matMenuItem) {
            this.matMenuItem.disabled = disabled;
        }
        if (this.matMiniFabButton) {
            this.matMiniFabButton.disabled = disabled;
        }
        if (this.matSlideToggle) {
            this.matSlideToggle.disabled = disabled;
        }
        if (this.matTab) {
            this.matTab.disabled = disabled;
        }
        if (this.multiselectStructure) {
            // this.multiselectStructure.disabled = disabled;
            console.error('TODO: multiselectStructure disable programmatically');
        }
        if (this.pegaseMenuEntry) {
            this.pegaseMenuEntry.disabled = disabled;
        }
        if (this.cdkDropList) {
            this.cdkDropList.disabled = disabled;
        }
        if (this.matIconButton) {
            this.matIconButton.disabled = disabled;
        }
    }
}
